import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { ISideNavItems } from '../../models/side-menu';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;

  fillerNav = ISideNavItems;
  currentNavName: string = 'Dashboard';
  isSidenavOpen = true;

  private _mobileQueryListener: () => void;
  matchedNav: any;

  constructor(private router: Router) {
    const changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher) as MediaMatcher;

    this.mobileQuery = media.matchMedia('(max-width: 400px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    // Listen for route changes and update the currentNavName based on the active route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      const currentRoute = this.router.url.split('/').pop();  // Get the current route name
      this.matchedNav = this.fillerNav.find(nav => nav.name.toLowerCase() === currentRoute?.toLowerCase()) ?  this.fillerNav.find(nav => nav.name.toLowerCase() === currentRoute?.toLowerCase()) : '';
      this.currentNavName = this.matchedNav ? this.matchedNav.name : '';
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);
}
